'use strict';

import './Input.less';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import Assets from '../../system/Assets';

export default class Input extends React.Component {
	componentDidMount() {
		// This assumes that falsy values are empty as far as optional is concerned. This assumption would not be
		// valid if the input allowed falsy values e.g. the number 0.
		const isEmpty = !this.props.value;

		if (isEmpty && this.props.optional && this.props.onValidate) {
			this.props.onValidate(true);
		}
	}

	render() {
		const classes = classnames(
			'Input',
			this.props.valid && 'valid',
			this.props.className,
			this.props.error && 'invalid',
			this.props.disabled && 'disabled'
		);

		const asteriskToken = this.props.hasAsterisk ? <span className="asterisk">*</span> : '';
		const tooltipId = this.props.tooltipText ? this.props.name + '-tooltip' : undefined;

		const labelInner = (
			<div className="label">
				{this.props.label}
				{asteriskToken}
				{tooltipId && (
					<img
						className="tooltip-icon"
						src={Assets.get('icon-info').url}
						data-tip
						data-for={tooltipId}
					/>
				)}
			</div>
		);

		let inner;

		if (this.props.virtualLabel) {
			inner = (
				<div className="virtualLabel">
					{labelInner}
					{this.props.children}
				</div>
			);
		} else {
			inner = (
				<label>
					{this.props.noLabel ? null : labelInner}
					{this.props.children}
				</label>
			);
		}

		return (
			<div>
				{tooltipId && (
					<ReactTooltip id={tooltipId} effect="solid" place="right">
						<span>{this.props.tooltipText}</span>
					</ReactTooltip>
				)}
				<div className={classes}>
					{inner}
					{this.props.error && <div className="error">{this.props.error}</div>}
				</div>
			</div>
		);
	}
}

Input.propTypes = {
	name: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	label: PropTypes.string,
	noLabel: PropTypes.bool,
	error: PropTypes.string,
	valid: PropTypes.bool,
	value: PropTypes.any,
	className: PropTypes.string,
	optional: PropTypes.bool,
	onValidate: PropTypes.func,
	// CORE-901: This is used to make the <label> not contain the inner elements, iOS Safari does not handle this well
	virtualLabel: PropTypes.bool,
	hasAsterisk: PropTypes.bool,
	tooltipText: PropTypes.string,
	disabled: PropTypes.bool
};
